import { Component, OnInit, Inject } from '@angular/core';
import { EventLog } from '../../dto/event-log';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

/**
 * This component is implements Mat Dialog showing method
 * and shows event logs in modal window
 */
@Component({
  selector: 'app-show-event-logs-dialog',
  templateUrl: './show-event-logs-dialog.component.html',
  styleUrls: ['./show-event-logs-dialog.component.css']
})
export class ShowEventLogsDialogComponent implements OnInit {
  /**
   * Modal widnow title
   */
  public title: string;
  /**
   * List of event logs whos need to show
   */
  public list: EventLog[];

  constructor(
    public dialogRef: MatDialogRef<ShowEventLogsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  /**
   * Setting title and list of data
   */
  ngOnInit() {
    if (this.data != null) {
      this.title = this.data.title;
      this.list  = this.data.list;
    }
  }

  /**
   * Close modal window on ok pressed
   */
  onOkClick(): void {
    this.dialogRef.close('ok');
  }
}
